// This file is auto-generated during the build process
export const BUILD_VERSION = "20260729-4";
export const BUILD_DATE = "2026-07-29T15:56:27.849Z";
